
import { createBrowserRouter, createRoutesFromElements, Route, } from 'react-router-dom'
import { ABOUT, CONTACT, EVENT, HOME, TEAM, WORK } from '../constants/constants'
import HomePage from '../pages/HomePage'
import AboutPage from '../pages/AboutPage'
import OurWorkPage from '../pages/OurWorkPage'
import EventPage from '../pages/EventPage'
import NotFound from '../components/NotFound'
import HeaderComponent from '../components/HeaderComponent'
import ContactPage from '../pages/ContactPage'
import TeamPage from '../pages/TeamPage'


const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route element={<HeaderComponent />}>
                <Route path={`${HOME}`} index element={<HomePage />} />
                <Route path={`${ABOUT}`} element={<AboutPage />} />
                <Route path={`${WORK}`} element={<OurWorkPage />} />
                <Route path={`${EVENT}`} element={<EventPage />} />
                <Route path={`${CONTACT}`} element={<ContactPage />} />
                <Route path={`${TEAM}`} element={<TeamPage />} />
            </Route>
            <Route path='*' element={<NotFound />} />
        </>
    )
)


export {
    router
}